import { useUsers } from '..';
import _ from 'lodash';
import { useMemo } from 'react';
export function useMyUser() {
    const patients = useUsers();
    return useMemo(() => _.first(patients), [patients]);
}
